class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onSubmitHandler = this.onSubmitHandler.bind(this);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', debounce(this.onSubmitHandler.bind(this), 250));

    this.querySelectorAll('facet-remove a, .active-facets__button-remove').forEach((link) => {
      link.addEventListener('click', this.onActiveFilterClick.bind(this));
    });

    this.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      select.addEventListener('change', this.onSubmitHandler.bind(this));
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const searchParams = this.createSearchParams(form);
    const hash = window.location.hash || '';
    this.onSubmitForm(searchParams, event, hash);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event, hash) {
    FacetFiltersForm.renderPage(searchParams, event, true, hash);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const currentHash = window.location.hash || '';
    let url = event.currentTarget.href;

    if (currentHash && !url.includes(currentHash)) {
      url += currentHash;
    }

    const searchParams = url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?') + 1);
    FacetFiltersForm.renderPage(searchParams, null, true, currentHash);
  }

  static renderPage(searchParams, event, updateURLHash = true, currentHash = '') {
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, currentHash);

    FacetFiltersForm.filterData = [];

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    fetch(`${window.location.pathname}?${searchParams}`)
      .then((response) => response.text())
      .then((html) => {
        // FacetFiltersForm.renderProductGridContainer(html);
        renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderFilters(html); 

        if (window.hideRetailPricesForWholesale) {
          hideRetailPrices();
        }
      });
  }

  static updateURLHash(params, currentHash) {
    history.pushState(params, '', `${window.location.pathname}?${params}${currentHash}`);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    document.getElementById('FacetFiltersForm').innerHTML = parsedHTML.getElementById('FacetFiltersForm').innerHTML;
  }

  // static updateListDisplay(hash) {
  //   // First, remove both classes to ensure a clean state
  //   document.querySelectorAll('.isc-collection-list-grid, .isc-collection-list-item-detail, .isc-collection-list-item, .isc-collection-list-link').forEach(el => {
  //     el.classList.remove('grid', 'list');
  //   });
  //   // Now, add the correct class
  //   document.querySelectorAll('.isc-collection-list-grid, .isc-collection-list-item-detail, .isc-collection-list-item, .isc-collection-list-link').forEach(el => {
  //     el.classList.add(hash);
  //   });

  //   // Update pagination anchors
  //   document.querySelectorAll('.pagination__item').forEach(link => {
  //     if(link.href) {
  //       link.href = link.href.split('#')[0] + '#' + hash;
  //     }
  //   });
  // };

  // static renderProductGridContainer(html) {
  //   const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  //   document.getElementById('ProductGridContainer').innerHTML = parsedHTML.getElementById('ProductGridContainer').innerHTML;

  //   const hash = window.location.hash === '#list' ? 'list' : 'grid'; // Default to grid
  //   FacetFiltersForm.updateListDisplay(hash);

  //   // If wholesale hide retail prices are enabled, hide retail prices. This function `hideRetailPrices` is defined in the theme.liquid file.
  //   if (typeof hideRetailPrices === 'function') {
  //     hideRetailPrices();
  //   }
  //   // Update product card list titles
  //   updateProductCardTitle();
  // }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    document.getElementById('ProductCount').innerHTML = parsedHTML.getElementById('ProductCount').innerHTML;
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);

function debounce(fn, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', (event) => {
      event.preventDefault();
      const currentHash = window.location.hash || '';
      let url = event.currentTarget.href;
      if (currentHash && !url.includes(currentHash)) {
        url += currentHash;
      }
      window.location.href = url;
    });
  }
}

customElements.define('facet-remove', FacetRemove);
